type ButtonProps = {
  text: string;
  disabled: boolean;
};
const Button = ({ text, disabled }: ButtonProps) => {
  return (
    <button className="button" disabled={disabled}>
      {text}
    </button>
  );
};

export default Button;
